export default __webpack_public_path__ + "resources/icons/d320-ecc5.webp";